import { useImperativeHandle } from 'react';
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default function useCalendarRef(calendarRef, {
  navigate
}) {
  useImperativeHandle(calendarRef, () => ({
    navigate
  }), [navigate]);
}